
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class ContainerSize extends Vue {
    @Prop({ type: Number, default: undefined }) readonly minHeight?: number;

    get containerElement(): HTMLDivElement {
      return this.$refs.container as HTMLDivElement;
    }

    get styles(): any {
      if (!this.minHeight) {
        return;
      }
      return `min-height: ${this.minHeight}px`;
    }

    mounted() {
      this.resize();
    }

    updated() {
      this.resize();
    }

    resize() {
      const height = this.containerElement.clientHeight;
      if (height === this.minHeight) {
        return;
      }
      this.$emit('update:minHeight', height)
    }
  }
